import React, { useState } from 'react';

/**
 * Responsive product image gallery. Accepts an array of image URLs and shows
 * a large main image with clickable thumbnails below. Gracefully degrades
 * when only one image is available.
 */
export default function ImageGallery({ images = [], alt = '' }) {
  const clean = images.filter(Boolean);
  const [idx, setIdx] = useState(0);
  if (clean.length === 0) {
    return (
      <div className="aspect-square bg-gray-50 rounded-lg flex items-center justify-center">
        <p className="text-gray-500">No image available</p>
      </div>
    );
  }
  const main = clean[Math.min(idx, clean.length - 1)];
  return (
    <div className="w-full" data-testid="product-gallery">
      <div className="w-full bg-gray-50 rounded-xl overflow-hidden border border-gray-100 aspect-square flex items-center justify-center">
        <img
          src={main}
          alt={alt}
          className="w-full h-full object-contain transition-opacity duration-200"
          data-testid="product-image"
        />
      </div>
      {clean.length > 1 && (
        <div className="mt-3 flex gap-2 overflow-x-auto">
          {clean.map((src, i) => (
            <button
              key={src + i}
              onClick={() => setIdx(i)}
              type="button"
              className={`flex-shrink-0 w-16 h-16 rounded-lg overflow-hidden border-2 transition-all ${
                i === idx ? 'border-[#334155]' : 'border-gray-200 hover:border-gray-400'
              }`}
              data-testid={`gallery-thumb-${i}`}
            >
              <img src={src} alt="" className="w-full h-full object-cover" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
